import { render } from "./CruGKE.vue?vue&type=template&id=6ffd5eca&scoped=true&ts=true"
import script from "./CruGKE.vue?vue&type=script&lang=ts"
export * from "./CruGKE.vue?vue&type=script&lang=ts"

import "./CruGKE.vue?vue&type=style&index=0&id=6ffd5eca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffd5eca"]])

export default __exports__